module.exports = __webpack_public_path__ + "static/img/Dougal_Howard_mobile.443cb1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dougal_Howard_mobile.jpg
// module id = Dr5d
// module chunks = 0